import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { httpClient } from '@lib/httpClient';
import {
  ContactState,
  IContactSubmitPayload,
  IContactSubmitResponse
} from './types';

export const useContactStore = create<ContactState>()(
  devtools((_set, _get) => ({
    submitContact: async (payload: IContactSubmitPayload) => {
      try {
        const endpoint = '/api/contato';
        const { data } = await httpClient.post<IContactSubmitResponse>(
          endpoint,
          payload
        );
        return data;
      } catch {
        return null;
      }
    }
  }))
);
